<template>
  <multipane class="custom-resizer" layout="horizontal"
    @paneResize="onResized">
    <v-layout row wrap>
      <v-flex sm12 class="pane">
        <v-layout row wrap class="top-container">
          <v-flex md8>
            <v-layout row wrap>
              <v-flex v-if="
                isInvAvailable &&
                parameterNameMap['inverter'] &&
                Object.keys(parameterNameMap['inverter']).length > 0
              " :class="emMfmFlexClass">
                <InverterDataTable :nameMap="deviceNameMap['inverter']" :parameter="invParameter"
                  :parameterNameMap="parameterNameMap['inverter']" :cardHeight="invHeight" />
              </v-flex>
              <v-flex v-if="isEmAvailable || isMfmAvailable" :class="invFlexClass">
                <v-layout column>
                  <v-flex v-if="
                    isEmAvailable &&
                    parameterNameMap['energy meter'] && 
                    Object.keys(parameterNameMap['energy meter']).length > 0"
                    >
                    <EmDataTable :nameMap="deviceNameMap['energy meter']" :parameter="emParameter"
                      :parameterNameMap="parameterNameMap['energy meter']" :cardHeight="meterHeight" :tableHeight="emMfmTableHeight" />
                  </v-flex>
                  <v-flex v-if="
                    isMfmAvailable &&
                    parameterNameMap['mfm'] &&
                    Object.keys(parameterNameMap['mfm']).length > 0
                  ">
                    <MfmDataTable :nameMap="deviceNameMap['mfm']" :parameter="mfmParameter"
                      :parameterNameMap="parameterNameMap['mfm']" :cardHeight="meterHeight" :tableHeight="emMfmTableHeight" />
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex pa-0 md4>
            <ComputedDataCards v-if="isComputedCardAvailable" />
            <WsData v-if="showWeatherStation" :nameMap="deviceNameMap['weather station']"
              :parameter="wsParameter" :parameterNameMap="parameterNameMap['weather station']"
              :cardHeight="wsHeight" />
            <ScbDataTable v-if="!isWsAvailable && isScbAvailable &&
                parameterNameMap['scb'] &&
                Object.keys(parameterNameMap['scb']).length > 0 && Object.keys(deviceNameMap).length > 0" :nameMap="deviceNameMap['scb']"
              :parameter="scbParameter" :parameterNameMap="parameterNameMap['scb']"
              :status="statusObject['scb']" :cardHeight="wsHeight" />
            <StatusCards class="pt-1" />
          </v-flex>
        </v-layout>
        <multipane-resizer v-if="isWsAvailable && isScbAvailable" />
      </v-flex>
      <v-flex pa-0 sm12 v-if="showWeatherStation && isScbAvailable &&
          parameterNameMap['scb'] &&
          Object.keys(parameterNameMap['scb']).length > 0" class="pane">
        <ScbDataTable v-if="Object.keys(deviceNameMap).length > 0" :nameMap="deviceNameMap['scb']" :parameter="scbParameter"
          :parameterNameMap="parameterNameMap['scb']" :status="scbStatus" :cardHeight="scbHeight" />
      </v-flex>
    </v-layout>
  </multipane>
</template>

<script>
import _ from "lodash";
import { reactive, toRefs, onMounted, watch } from 'vue';
import { Multipane, MultipaneResizer } from 'vue-multipane';
import LiveDb from "@/services/LiveDb";
import {
  mapGettersMixin
} from "@/util/mixin/index";
import {
  mapGetters,
} from "vuex";
import store from '@/store/index'
import InverterDataTable from "@/components/live-dash/DeviceTable/InverterDataTable";
import ScbDataTable from "@/components/live-dash/DeviceTable/ScbDataTable";
import EmDataTable from "@/components/live-dash/DeviceTable/EmDataTable";
import MfmDataTable from "@/components/live-dash/DeviceTable/MfmDataTable";
import WsData from "@/components/live-dash/DeviceTable/WsDataTable";
import StatusCards from "@/components/live-dash/SubComponent/StatusCards";
import ComputedDataCards from "@/components/live-dash/SubComponent/ComputedDataCards";

export default {
  mixins: [mapGettersMixin],
  components: {
    Multipane,
    MultipaneResizer,
    InverterDataTable,
    MfmDataTable,
    EmDataTable,
    StatusCards,
    ComputedDataCards,
    WsData,
    ScbDataTable,
  },
  data() {
    return {
      parameterNameMap: {},
      deviceNameMap: {}
    };
  },
  computed: {
    ...mapGetters(["getSelectedPlantId", "getRules"]),
    availableDeviceList() {
      const accessConfig = this.getRules(["rule", "access_config"]);
      return accessConfig && accessConfig["live_device"] ?
        Object.keys(accessConfig["live_device"]) :
        [];
    },
    isComputedCardAvailable() {
      const accessConfig = this.getRules(["rule", "access_config"]);
      if (accessConfig && accessConfig["live_device"]) {
        return this.availableDeviceList.some((el) => {
          return accessConfig["live_device"][el].length > 0;
        });
      }
      return false;
    },
    parameterObject() {
      const compConfig = this.getRules(["rule", "comp_config"]);
      return compConfig &&
        compConfig["live_monitoring"] &&
        !_.isEmpty(compConfig["live_monitoring"]) ?
        compConfig["live_monitoring"].options.parameters :
        {};
    },
    statusObject() {
      const compConfig = this.getRules(["rule", "comp_config"]);
      return compConfig &&
        compConfig["live_monitoring"] &&
        !_.isEmpty(compConfig["live_monitoring"]) && compConfig["live_monitoring"].options.status ?
        compConfig["live_monitoring"].options.status :
        {};
    },
    scbStatus() {
      return !_.isEmpty(this.statusObject) && this.statusObject['scb'] ? this.statusObject['scb'] : {}
    },
    isEmAvailable() {
      return this.availableDeviceList.includes("Energy Meter");
    },
    isMfmAvailable() {
      return this.availableDeviceList.includes("MFM");
    },
    isWsAvailable() {
      return this.availableDeviceList.includes("Weather Station");
    },
    isInvAvailable() {
      return this.availableDeviceList.includes("Inverter");
    },
    isScbAvailable() {
      return this.availableDeviceList.includes("SCB");
    },
    emMfmFlexClass() {
      // Check for em and mfm
      return this.isEmAvailable || this.isMfmAvailable ? "md7" : "md12";
    },
    invFlexClass() {
      return this.isInvAvailable ? "md5" : "md12";
    },
    invParameter() {
      return !_.isEmpty(this.parameterObject) ?
        this.parameterObject["inverter"] :
        [];
    },
    mfmParameter() {
      return !_.isEmpty(this.parameterObject) ?
        this.parameterObject["mfm"] :
        [];
    },
    emParameter() {
      return !_.isEmpty(this.parameterObject) ?
        this.parameterObject["energy meter"] :
        [];
    },
    wsParameter() {
      return !_.isEmpty(this.parameterObject) ?
        this.parameterObject["weather station"] :
        [];
    },
    scbParameter() {
      return !_.isEmpty(this.parameterObject) ?
        this.parameterObject["scb"] :
        [];
    },
    showWeatherStation() {
      return (
        this.isWsAvailable &&
        this.parameterNameMap["weather station"] &&
        Object.keys(this.parameterNameMap["weather station"]).length > 0
      );
    },
  },
  setup() {
    const state = reactive({
      invHeight: '684px',
      wsHeight: '550px',
      scbHeight: '24vh',
      meterHeight: '248px',
      emMfmTableHeight: 'calc(248px - 53px)',
      deviceList: []
    });
    onMounted(() => {
      const accessConfig = store.getters.getRules(["rule", "access_config"])
      state.deviceList = accessConfig && accessConfig["live_device"] ?
        Object.keys(accessConfig["live_device"]) :
        [];
      if (state.deviceList.includes("SCB")) {
        state.meterHeight = state.deviceList.includes("Energy Meter") &&
          state.deviceList.includes("MFM") ? '248px' : '502px'
        state.emMfmTableHeight = `calc(${state.meterHeight} - 53px)`
      } else {
        state.meterHeight = state.deviceList.includes("Energy Meter") &&
          state.deviceList.includes("MFM") ? '367px' : '734px'
        state.emMfmTableHeight = `calc(${state.meterHeight} - 53px)`
      }
    });
    
    const onResized = (pane, container, size) => {
      state.invHeight = `calc(${size} - 61px)`
      state.wsHeight = `calc(${size} - 195px)`
      state.meterHeight = state.deviceList.includes("Energy Meter") &&
            state.deviceList.includes("MFM") ? 
              `${(container.offsetTop / 2) - 10}px` : `${container.offsetTop - 10}px`
      state.emMfmTableHeight = `calc(${state.meterHeight} - 53px)`
      state.scbHeight = `${document.documentElement.clientHeight - container.offsetTop - 280}px`
    };

    watch(
      () =>  store.getters.getSelectedPlantId,
      () => {
        const accessConfig = store.getters.getRules(["rule", "access_config"])
        state.deviceList = accessConfig && accessConfig["live_device"] ?
          Object.keys(accessConfig["live_device"]) :
          [];
        if (state.deviceList.includes("SCB")) {
          state.meterHeight = state.deviceList.includes("Energy Meter") &&
            state.deviceList.includes("MFM") ? '248px' : '502px'
          state.emMfmTableHeight = `calc(${state.meterHeight} - 53px)`
        } else {
          state.meterHeight = state.deviceList.includes("Energy Meter") &&
            state.deviceList.includes("MFM") ? '367px' : '734px'
          state.emMfmTableHeight = `calc(${state.meterHeight} - 53px)`
        }
      }
    );

    return {
      ...toRefs(state),
      onResized
    };
  },
  async mounted() {
    this.invHeight = this.isWsAvailable && this.isScbAvailable ? '452px' : '684px'
    this.wsHeight = this.isWsAvailable && this.isScbAvailable ? '318px' : '550px'
    const param = {
      plantId: this.getSelectedPlantId,
      deviceList: [],
    };

    if (this.isInvAvailable) {
      param.deviceList.push("inverter");
    }
    if (this.isEmAvailable) {
      param.deviceList.push("energy meter");
    }
    if (this.isMfmAvailable) {
      param.deviceList.push("mfm");
    }
    if (this.isWsAvailable) {
      param.deviceList.push("weather station");
    }
    if (this.isScbAvailable) {
      param.deviceList.push("scb");
    }

    this.getParameterMap(param);
    this.getDeviceIdMap(param);
  },
  methods: {
    async getParameterMap(payload) {
      const response = await LiveDb.getParameterMapConfig(payload);
      this.parameterNameMap = response.data.message;
    },
    async getDeviceIdMap(payload) {
      const response = await LiveDb.getDeviceIdMap(payload);
      this.deviceNameMap = response.data;
    }
  },
  watch: {
    getSelectedPlantId() {
      // Resetting the pane resizer to normal
      document.querySelector('.top-container').style.removeProperty('height')
      this.invHeight = this.isWsAvailable && this.isScbAvailable ? '452px' : '684px'
      this.wsHeight = this.isWsAvailable && this.isScbAvailable ? '318px' : '550px'
      const param = {
        plantId: this.getSelectedPlantId,
        deviceList: [],
      };

      if (this.isInvAvailable) {
        param.deviceList.push("inverter");
      }
      if (this.isEmAvailable) {
        param.deviceList.push("energy meter");
      }

      if (this.isMfmAvailable) {
        param.deviceList.push("mfm");
      }

      if (this.isWsAvailable) {
        param.deviceList.push("weather station");
      }

      if (this.isScbAvailable) {
        param.deviceList.push("scb");
      }

      this.getParameterMap(param);
      this.getDeviceIdMap(param);
    },
  },
  filters: {
    checkEmpty(value) {
      return typeof value !== "number" ? 0 : value;
    }
  }
};
</script>

<style>
.multipane-resizer {
  margin: -1px auto 1px auto; 
  top: 10; 
  height: 5px;
  width: 100px;
}

.theme--dark .multipane-resizer {
	border-top: 0.5px solid #fff;
  border-bottom: 0.5px solid #fff;
}

.theme--light .multipane-resizer {
	border: 0.5px solid #747D8C;
}

.multipane-resizer:hover {
  cursor: ns-resize;
}

</style>
